import { useState } from 'react';
import dayjs from 'dayjs';
import {
  Modal,
  Typography,
  Form,
  notification,
  Radio,
  Button,
  Popconfirm,
} from 'antd';

import MESSAGES from '../../enums/Messages';

import { postTemplateDocuments } from '../../api/module/templates';
import CustomUpload from '../../components/CustomUpload';
import { catchExceptionSRate } from '../../utils/helpers/helpers';

const { Title } = Typography;
const validateMessages = {
  required: 'El campo ${label} es requerido!',
};

const LoadTemplateForm = ({
  isModalOpen,
  setIsModalOpen,
  template_type_id,
  onRefresh,
}) => {
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const onFinish = async (data) => {
    try {
      setLoading(true);
      let formData = new FormData();
      if (
        data.plantilla.fileList[0].type ==
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      ) {
        data.plantilla = data.plantilla.fileList[0].originFileObj;
        data.tipo_plantilla = template_type_id;
        data.fecha = dayjs().format('YYYY-MM-DD');

        for (let prop in data) {
          if (data.hasOwnProperty(prop)) formData.append(prop, data[prop]);
        }
        await postTemplateDocuments(formData);
        setLoading(false);
        onRefresh();
        notification.success({
          message: MESSAGES.SUCCESS_MSG,
          description: MESSAGES.DESC_SUCCESS_MSG,
          duration: 2,
        });
      }
    } catch (err) {
      setLoading(false);
      catchExceptionSRate(err, MESSAGES.DESC_ERROR_POST_MSG);
    }
  };

  return (
    <>
      <Modal
        title={
          <Title level={4} style={{ marginBottom: 0 }}>
            Agregar nueva version de Plantilla
          </Title>
        }
        open={isModalOpen}
        closable={false}
        maskClosable={false}
        footer={[
          <Button
            key="back"
            onClick={() => setIsModalOpen(false)}
            disabled={loading}
          >
            Cancelar
          </Button>,
          <Popconfirm
            title="¿Está seguro(a) de la información registrada para esta nueva plantilla?"
            okText="Si"
            cancelText="No"
            onConfirm={() => {
              form.submit();
            }}
          >
            <Button
              key="submit"
              type="primary"
              htmlType="button"
              loading={loading}
              disabled={loading}
            >
              Cargar
            </Button>
          </Popconfirm>,
        ]}
        width={800}
        destroyOnClose
      >
        <Form
          form={form}
          layout="vertical"
          name="basic"
          validateMessages={validateMessages}
          onFinish={onFinish}
        >
          <CustomUpload
            file_type={4}
            upload_type={2}
            name="plantilla"
            label="Documento"
            required={true}
          />
          <Form.Item
            label="¿El logo de este documento cambia según la organización ejecutora?"
            name="reemplazo_logo"
            rules={[{ required: true, message: 'es requerido' }]}
          >
            <Radio.Group>
              <Radio value={true}>Si</Radio>
              <Radio value={false}>No</Radio>
            </Radio.Group>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default LoadTemplateForm;
